import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import moment from "moment";
import { FormDateInput } from "form";
import { ACTION_VIEW_MODE } from "constants/action-form";
import Title from "../../Typography/Title";
import { ActionTopBoxStyled } from "../common-styled/ActionTopBoxStyled";
import AnalysisTypeInput from "components/action-inputs/analysis-type/AnalysisTypeInput";

const AnalysisBaseInfo = ({ viewMode = "view" }) => {
  const { t } = useTranslation();
  const { setFieldValue, validateForm } = useFormikContext();
  const isViewMode = viewMode === ACTION_VIEW_MODE.view;

  const handleDateChange = (newDate) => {
    setFieldValue("datetimePerformed", newDate).then(() => {
      validateForm();
    });
    setFieldValue("datetimePerformedEnd", newDate).then(() => {
      validateForm();
    });
  };

  return (
    <ActionTopBoxStyled>
      <Title title={t("ActionModal.AnalysisType")} />
      <AnalysisTypeInput isViewMode={isViewMode} />
      <Title title={t("ActionModal.AnalysisDate")} />
      <FormDateInput
        name="datetimePerformed"
        shouldHaveErrorBehaviorAfterSubmit
        isViewMode={isViewMode}
        formatValue={(value) => moment(value).toISOString()}
        onChange={handleDateChange}
      />
    </ActionTopBoxStyled>
  );
};

export default AnalysisBaseInfo;
